import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowReferenceFailureAlert = ({
  handleRequestReferences
}) => /*#__PURE__*/_jsx(UIAlert, {
  use: "inline",
  type: "warning",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-management.references.failureTitle"
  }),
  children: /*#__PURE__*/_jsx(UIButtonWrapper, {
    children: /*#__PURE__*/_jsx(TrackableButton, {
      onClick: handleRequestReferences,
      size: "extra-small",
      use: "tertiary-light",
      trackableKey: Trackables.RETRY_FAILED_REFERENCES,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.references.failureButton"
      })
    })
  })
});
export default WorkflowReferenceFailureAlert;